module.exports = __webpack_public_path__ + "img/0Q3B1891_L_BlackMatted.ec61d629.jpg";